import { useContext } from 'react'

import AddProcedure from '../context/addProcedure'

const useAddProcedure = () => {
    const {
        procedure,
        setProcedure,
        items,
        setItems,
        limit,
        setLimit,
        data,
        page,
        hasNextPage,
        hasPrevPage,
        handleNext,
        handlePrev,
        handleHeaderQuery,
        handleFilterQuery,
        isFiltered,
        handleClearFilters,
        total,
        setIsFiltered,
        showPagination,
        setFixed,
        resetQuery,
        docs,
        setDocs
      } = useContext(AddProcedure);

  return {
        procedure,
        setProcedure,
        items,
        setItems,
        limit,
        setLimit,
        data,
        page,
        hasNextPage,
        hasPrevPage,
        handleNext,
        handlePrev,
        handleHeaderQuery,
        handleFilterQuery,
        isFiltered,
        handleClearFilters,
        total,
        setIsFiltered,
        showPagination,
        setFixed,
        resetQuery,
        docs,
        setDocs
  };
}

export default useAddProcedure